const FEATURES = {
  Aluguel: 1,
}

const ACCESS = {
  EvenPartnerCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser"],
  EvenRepresentativeCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser", "RepresentativeAdmin", "RepresentativeUser"],
  EvenResellerCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser", "RepresentativeAdmin", "RepresentativeUser", "ResellerAdmin", "ResellerUser"],
  
  OnlySaleChannelCanAccess : ["SaleChannelAdmin", "SaleChannelUser"],
  OnlyPartnerCanAccess : ["PartnerAdmin", "PartnerUser"],
  OnlyRepresentativeCanAccess : ["RepresentativeAdmin", "RepresentativeUser"],
  OnlyResellerCanAccess : ["ResellerAdmin", "ResellerAdmin"],
  OnlyMerchantCanAccess : ["MerchantAdmin", "MerchantUser"],

  OnlyAdminsCanAccess : ["SaleChannelAdmin", "PartnerAdmin", "RepresentativeAdmin", "ResellerAdmin"],

  OnlySystemAdminsCanAccess : ["SystemAdmin"],
};

const ROLES = {
  SystemAdmin: 1,
  SaleChannel: 2,
  Partner: 3,
  Representative: 4,
  Reseller: 5,
  Merchant: 6,
  Onboarding: 7,
  Finance: 8
}

export const getMenuData = [
  {
    title: "Dashboard",
    key: "dashboards",
    icon: "fa fa-area-chart",
    count: 4,
    children: [
      {
        title: "Analítico",
        key: "dashboardAnalytics",
        url: "/dashboard/analytics",
        roles: ACCESS.OnlySaleChannelCanAccess
      },
      {
        title: "Analítico EC",
        key: "dashboardAnalytics-ec",
        url: "/dashboard/analytics/ec",
        roles: ACCESS.OnlyMerchantCanAccess
      },
      {
        title: "Analítico Parceiro",
        key: "dashboardAnalytics-partner",
        url: "/dashboard/analytics/pt",
        roles: ACCESS.OnlyPartnerCanAccess
      },
      {
        title: "Analítico Representante",
        key: "dashboardAnalytics-representative",
        url: "/dashboard/analytics/rt",
        roles: ACCESS.OnlyRepresentativeCanAccess
      },
      {
        title: "Faturamento",
        key: "dashboard-merchant",
        url: "/dashboard/faturamento",
      },
      {
        title: "Recebimento",
        key: "dashboardreceivement",
        url: "/dashboard/receivement",
        roles: [ "MerchantAdmin", "MerchantUser", "SaleChannelAdmin", "SaleChannelUser" ]
      },
      {
        title: "Performance EC/DIA",
        key: "dashboards/performance/merchant",
        url: "/dashboard/performance/estabelecimento",
        roles: ACCESS.EvenResellerCanAccess
      },
      {
        title: "Performance EC/MES",
        key: "dashboards/performance/merchant-month",
        url: "/dashboard/performance/estabelecimento-mes",
        roles: ACCESS.EvenResellerCanAccess
      },
 
    ]
  },


  {
    category: true,
    title: "Gestão Comercial",
    key: "comercial",
    roles: ACCESS.EvenRepresentativeCanAccess,
  },
  {
    title: "Parceiros",
    key: "partners",
    icon: "fa fa-sitemap",
    url: "/parceiros",
    roles: ACCESS.OnlySaleChannelCanAccess,
  },
  {
    title: "Representantes",
    key: "representatives",
    icon: "fa fa-users",
    url: "/representantes",
    roles: ACCESS.EvenPartnerCanAccess,
  },
  {
    title: "Revendedores",
    key: "resellers",
    icon: "fa fa-user",
    url: "/revendedores",
    roles: ACCESS.EvenRepresentativeCanAccess,
  },

  {
    category: true,
    title: "Gestão de Clientes",
    key: "client-manager",
    roles: ACCESS.EvenResellerCanAccess
  },

  {
    title: "Estabelecimentos",
    key: "merchant",
    icon: "fa fa-building",
    roles: ACCESS.EvenResellerCanAccess,
    children: [
      {
        title: "Todos",
        key: "allMerchants",
        url: "/estabelecimentos?all=true",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Ativo",
        key: "activeMerchants",
        url: "/estabelecimentos?idMerchantStatus=1",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Inativo",
        key: "inactiveMerchants",
        url: "/estabelecimentos?idMerchantStatus=2",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Pendente de Documentação",
        key: "documentationPendingMerchants",
        url: "/estabelecimentos?idMerchantStatus=3",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Aguardando Criação de Conta",
        key: "waitingAccountCreationMerchants",
        url: "/estabelecimentos?idMerchantStatus=4",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Suspenso",
        key: "suspendedMerchants",
        url: "/estabelecimentos?idMerchantStatus=5",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Encerrado",
        key: "terminatedMerchants",
        url: "/estabelecimentos?idMerchantStatus=6",
        roles: ACCESS.EvenPartnerCanAccess,
      }
    ]
  },

  {
    title: "Política Comercial",
    key: "politicacomercial",
    icon: "fa fa-percent",
    roles: ACCESS.EvenPartnerCanAccess,
    children: [
      {
        title: "Listar",
        key: "politicacomerciallistar",
        url: "/credenciamento/politica-comercial",
        roles: ACCESS.EvenPartnerCanAccess,
      },
      {
        title: "Adicionar",
        key: "politicacomercialadicionar",
        url: "/credenciamento/politica-comercial/adicionar",
        roles: ACCESS.EvenPartnerCanAccess,
      }
    ]
  },



  // // PagSeguro
  // {
  //   title: "PagSeguro",
  //   key: "pagseguro",
  //   icon: "fa fa-cubes",
  //   roles: [ROLES.SystemAdmin, ROLES.SaleChannel],
  //   children: [
  //     {
  //       title: "Cadastros Pendentes",
  //       key: "pagseguro/pendingInformation",
  //       url: "/pagseguro/aguardando-informacoes",
  //       roles: [ROLES.SystemAdmin, ROLES.SaleChannel]
  //     },
  //     {
  //       title: "Ativação Cliente",
  //       key: "pagseguro/onboarding",
  //       url: "/pagseguro/onboarding",
  //       roles: [ROLES.SystemAdmin, ROLES.SaleChannel]
  //     }
  //   ]
  // },

  // PagSeguro
  // {
  //   title: "Comunicação",
  //   icon: "fa fa-comments",
  //   key: "notifications",
  //   count: 2,
  //   roles: ["SystemAdmin", "Salechannelx", "Managerx", "Coordinatorx", "Supervisorx", "Operatorx"],
  //   children: [
  //     {
  //       title: "Envio de contrato",
  //       key: "notifications-contract",
  //       icon: "fa fa-handshake-o",
  //       url: "/notification/contract",
  //       roles: ["SystemAdmin"]
  //     },
  //     {
  //       title: "Campanha App",
  //       key: "notifications-campaign",
  //       icon: "fa fa-envelope",
  //       url: "/notifications/campaign",
  //       roles: ["SystemAdmin"]
  //     }

  //   ]
  // },

  {
    category: true,
    title: "Gestão de Equipamentos",
    key: "devicemanager",
    roles: ACCESS.OnlySaleChannelCanAccess,
  },

  {
    title: "POS / Maquinetas",
    key: "devices",
    icon: "fe fe-printer",
    roles: ACCESS.OnlySaleChannelCanAccess,
    url: "/maquinetas"
  },

 {
    category: true,
    title: "Gestão de Acessos",
    key: "acesscontrol",
    roles: ACCESS.OnlyAdminsCanAccess
  },
  {
    title: "Usuários",
    key: "users",
    icon: "fe fe-user",
    url: "/usuarios",
    roles: ACCESS.OnlyAdminsCanAccess
  },

  {
    title: "Gestão de Aluguel",
    key: "deviceRent",
    icon: "fe fe-printer",
    roles: ACCESS.OnlySaleChannelCanAccess,
    features: [FEATURES.Aluguel],
    children: [
      {
        title: "Contratos",
        key: "deviceRentList",
        url: "/aluguel/contratos",
        roles: ACCESS.OnlySaleChannelCanAccess,
      },
    ]
  },

  // Financeiro
  {
    category: true,
    title: "Financeiro",
    key: "finance"
  },

  {
    title: "Minhas Taxas",
    key: "fee",
    icon: "fa fa-percent",
    url: "/taxas",
    roles: ACCESS.OnlyMerchantCanAccess
  },

  {
    title: "Recebimentos",
    key: "recebimentos",
    icon: "fa fa-line-chart",
    url: "/recebimentos",
    roles: ACCESS.OnlySaleChannelCanAccess
  },

  {
    title: "Transferência de Saldo",
    key: "conciliacao-transferencia",
    icon: "fa fa-money",
    url: "/transferencia-saldo",
    roles: ACCESS.OnlySaleChannelCanAccess
  },

  {
    title: "Conciliação de Pag",
    key: "conciliacao",
    icon: "fa fa-money",
    url: "/conciliacao-pagamento",
    roles: ACCESS.OnlySaleChannelCanAccess
  },

  // Financeiro // Faturas
  {
    title: "Faturas",
    key: "invoices",
    icon: "fa fa-list-alt",
    roles: ACCESS.OnlySaleChannelCanAccess,
    children: [
      // {
      //   title: "Canal de Vendas",
      //   key: "invoices/saleChannel",
      //   icon: "fa fa-group",
      //   url: "/parceiros/canais-de-venda/fatura",
      //   roles: ["SystemAdmin", "SaleChannel"]
      // },
      {
        title: "Estabelecimento",
        key: "invoicesMerchant",
        icon: "fa fa-building",
        url: "/faturas/estabelecimentos",
        roles: ACCESS.OnlySaleChannelCanAccess
      },
    ]
  },
  // Financeiro // Liquidação
  // {
  //   title: "Liquidação",
  //   key: "finance/liquidation",
  //   icon: "fa fa-usd",
  //   roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //   children: [
  //     {
  //       title: "Overview",
  //       key: "finance/liquidation/overview",
  //       url: "/liquidacao/overview",
  //       roles: ["SystemAdmin", "Salechannelx", "Financex"],

  //     },

  //     {
  //       title: "Geração de CNAB",
  //       key: "finance/liquidation/cnab/index",
  //       url: "/liquidacao/geracao-arquivo-remessa",
  //       roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //     },
  //     {
  //       title: "Transferência em Lote",
  //       key: "finance/liquidation/cnab/payout",
  //       url: "/liquidacao/arquivo-remessa",
  //       roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //     },


  //   ],
  // },
  // {
  //   title: "Conciliação",
  //   key: "finance/conciliaton",
  //   icon: "fa fa-usd",
  //   roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //   children: [
  //     {
  //       title: "Transferências",
  //       key: "finance/conciliation/payoutConciliation",
  //       url: "/conciliacao/conciliacao-de-pagamentos",
  //       roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //     },
  //     {
  //       title: "Fluxo IN/OUT",
  //       key: "finance/conciliation/in-out",
  //       url: "/conciliacao/fluxo-entrada-saida",
  //       roles: ["SystemAdmin", "Salechannelx", "Financex"],
  //     },
  //   ]
  // },





  // Relatórios    
  {
    category: true,
    title: "Relatórios",
    key: "reports",
  },

  // Relatorios //Estabelecimentos
  {
    title: "Estabelecimentos",
    key: "merchant",
    icon: "fa fa-building",
    roles: ACCESS.EvenResellerCanAccess,
    children: [
      {
        title: "Apuração de Faturamento",
        key: "report/merchant/forecast",
        url: "/relatorio/estabelecimento/apuracao-de-faturamento"
      },
      {
        title: "Documentação Pendente",
        key: "report/merchant/pending-files",
        url: "/relatorio/estabelecimento/documentacao-pendente"
      },
    ]
  },



  // Relatorios // Devices
  {
    title: "POS / Maquinetas",
    key: "report/device",
    icon: "fe fe-printer",
    roles: ACCESS.EvenResellerCanAccess,
    children: [
      {
        title: "Última Transação",
        key: "report/device/last-transaction",
        url: "/relatorio/maquineta/ultima-transacao"
      },
    ]
  },

  // Relatorios // Transações
  {
    title: "Transações",
    key: "transactions",
    icon: "fe fe-hard-drive",
    roles: ACCESS.OnlySaleChannelCanAccess,
    children: [
      {
        title: "Não Sincronizadas",
        key: "transactions-unsync",
        url: "/transactions-unsync",
        roles: ACCESS.OnlySaleChannelCanAccess,
      },
      // {
      //   title: "Recapturar",
      //   key: "transactions-recapture",
      //   url: "/transacoes/recapturar",
      //   roles: ACCESS.OnlySaleChannelCanAccess,
      // },
    ]
  },


  // Operação 

  // {
  //   category: true,
  //   title: "Operação",
  //   key: "operation",
  //   roles: ["SystemAdmin"],
  // },
  // {
  //   title: "Estabelecimento",
  //   key: "operation-merchant",
  //   roles: ["SystemAdmin"],
  //   children:[
  //     {
  //       title: "Revisão de contratos",
  //       key: "merchantcontractreview",
  //       url: "/merchant/contract-review",
  //       roles: [
  //         "SystemAdmin"
  //         'role2',
  //       ]
  //     }

  //   ]
  // },

  // Auditoria
  {
    category: true,
    title: "Auditoria",
    key: "audit",
    roles: ACCESS.EvenResellerCanAccess
  },
  {
    title: "Suspeita de Fraude",
    key: "fraudanalisys",
    icon: "fa fa-user-secret",
    url: "/auditoria/suspeita-de-fraude",
    roles: ACCESS.EvenResellerCanAccess
  },

  // {
  //   title: "Eventos de Auditoria",
  //   key: "audit-events",
  //   icon: "fe fe-lock",
  //   url: "/auditoria/eventos",
  //   roles: ["SystemAdmin", "SaleChannel"]
  // },

  // // Configurações
  {
    category: true,
    title: "Configurações",
    key: "configurations",
    roles: ACCESS.OnlySaleChannelCanAccess
  },
  // {
  //   title: "Funcionalidades",
  //   key: "features",
  //   icon: "fa fa-toggle-on",
  //   url: "/configuracoes/funcionalidades",
  //   roles: ACCESS.OnlySaleChannelCanAccess
  // },


  {
    title: "Templates de E-mail",
    key: "emailtemplates",
    icon: "fa fa-envelope",
    count: 6,
    roles: ACCESS.OnlySaleChannelCanAccess,
    children: [
      {
        title: "Listar",
        key: "emailtemplateslist",
        url: "/email-templates",
        roles: ACCESS.OnlySaleChannelCanAccess,
      },
      {
        title: "Adicionar",
        key: "emailtemplatesadd",
        url: "/email-templates/add",
        roles: ACCESS.OnlySaleChannelCanAccess,
      }
    ]
  },

  {
    category: true,
    title: "Suporte",
    key: "support",
    roles: ACCESS.OnlySaleChannelCanAccess
  },

  {
    title: "Atendimentos",
    key: "support-tickets",
    icon: "fa fa-envelope",
    url: "/atendimentos",
    roles: ACCESS.OnlySaleChannelCanAccess
  },

  {
    title: "Suporte",
    key: "mytickets",
    icon: "fa fa-comments",
    url: "/suporte",
  },


  // SystemAdmin
  {
    category: true,
    title: "SystemAdmin",
    key: "SystemAdmin",
    roles: ACCESS.OnlySystemAdminsCanAccess
  },

  {
    title: "Autenticação",
    key: "authentication",
    icon: "fa fa-envelope",
    count: 6,
    roles: ACCESS.OnlySystemAdminsCanAccess,
    children: [
      {
        title: "Impersonar",
        key: "authImpersonate",
        url: "/autenticacao/impersonar",
        roles: ACCESS.OnlySystemAdminsCanAccess,
      },
    ]
  },

];
